import { createRenderer } from '../renderer';

export default createRenderer({
  headings: true,
});
